import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.css'],
  imports: [
    MaterialModule,
    SharedModule
  ],
  standalone: true
})
export class LocationListComponent implements OnInit {
  isLocationSelectable: boolean = false;
  locations: any;
  error: any;
  errorMessage: any;
  displayedColumns = ['select', 'code', 'name', 'onHand', 'position'];
  selection: any;
  itemName: string;

  constructor(public dialogRef: MatDialogRef<LocationListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.locations = this.data.locations;
    this.error = this.data.error;
    this.errorMessage = this.data.errorMessage;
    this.itemName = this.data.itemName;
    // this.isLocationSelectable = this.data.isLocationSelectable;


  }

  ngOnInit(): void {
    const initialSelection = [];
    const allowMultiSelect = true;
    this.selection = new SelectionModel<any>(allowMultiSelect, initialSelection);

    console.log(this.isLocationSelectable);
    if (this.isLocationSelectable == true) {
      this.displayedColumns = ['select', 'code', 'name', 'onHand', 'position'];
    } else {
      this.displayedColumns = ['code', 'name', 'onHand', 'position'];
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.locations.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.locations.forEach(row => this.selection.select(row));
  }
  closeDialog() {
    this.dialogRef.close('Pizza!');
  }

  saveLocation() {
    this.dialogRef.close(this.selection._selected[0]);
  }
}
